import { Tabs } from "antd";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import UserList from "./tabItems/UserList";
import AddUser from "./tabItems/AddUser";
import { setUser } from "../../store/slices/userSlice";

export const userTabConfig = {
    LIST: "1",
    ADD: "2"
}

const UsersTab = () => {
    const [currentTab, setCurrentTab] = useState(userTabConfig.LIST);
    const [tabTada, setTabData] = useState({});
    const dispatch = useDispatch();


    useEffect(() => {
        dispatch(setUser({}));
    }, [])

    const onSwitchTab = (key, data) => {
        setCurrentTab(key);
    } 

    const tabs = [
        {
          key: userTabConfig.LIST,
          label: 'User List',
          children: <UserList onSwitchTab={onSwitchTab} />,
        },
        {
            key: userTabConfig.ADD,
            label: 'Add / Modify User',
            children: <AddUser onSwitchTab={onSwitchTab} tabProps={{}} />,
        }
    ];

    const onChange = (key) => {
        setCurrentTab(key);
        if (key !== userTabConfig.ADD) {
            dispatch(setUser({}));
        }
    };

    return (
        <div>
            <div className="text-2xl pb-3">Users</div>
            <div className="px-4 border pb-6 bg-white pop-left">
                <Tabs defaultActiveKey="1" activeKey={currentTab} items={tabs} onChange={onChange} />
            </div>
        </div>
    )
}

export default UsersTab;